module.exports = __webpack_public_path__ + "img/login_banner.0b5ac90e.png";